// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a620a33","732":"4ac3508e","977":"1f71c893"}[chunkId] + ".chunk.js";
};